import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import trainingDetailsService from "./useTrainingDetailsService";

const useTrainingDetails = () => {
  const { id } = useParams();
  const {
    data: trainingData,
    isLoading: isLoadingTraining,
    error: errorTraining,
    refetch: refetchTraining,
  } = useQuery(
    ["trainingDetailsData", id],
    async () => await trainingDetailsService.getTrainingDetails(id)
  );

  return {
    trainingData,
    isLoadingTraining,
    errorTraining,
    refetchTraining,
  };
};

export default useTrainingDetails;
